(function () {
  angular.module('leanlaw').directive('trackClick', ['tracking', clickDirective]);
  function clickDirective(tracking) {
    return {
      restrict: 'A',
      priority: 100,
      // give it higher priority than built-in ng-click
      link: function (scope, element, attr) {
        if (!attr.ngModel) {
          element.bind('click', function () {
            var name = attr.trackClick || '-';
            var split = categoryAndEvent(name, 'Click');
            tracking.event(split[0], split[1]);
          });
        }
      }
    };
  }
  function categoryAndEvent(name, defaultCategory) {
    var split = name.split(':');
    if (split.length > 1) return split;
    return [defaultCategory, name];
  }
})();